import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment-timezone';
import { get } from 'lodash';

import Spinner from '../../sharedComponents/Spinner/Spinner';
import * as SecurityHelper from '../../../helpers/securityHelper';
import { getRoleAtLocation, getReadableRole } from '../../../helpers/rolesHelper';

export default class ReservationHistoryRow extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            iaLoading: get(props.rowData, 'internal_account_id', '') !== '',
            internalAccount: ''
        };
    }

    componentDidMount() {
        if (this.props.isInternal && this.state.iaLoading) {
            // Request the internal user name
            const url = `${process.env.API}/internal/account/user/${this.props.rowData.internal_account_id}`;
            const auth = SecurityHelper.getInternalAuthHeader();

            axios.get(url, { headers: { Authorization: auth } })
            .then((resp) => {
                const user = resp.data.user;
                let role = getRoleAtLocation(user, this.props.location);
                if (role !== '') {
                    role = `(${getReadableRole(role)})`;
                }
                this.setState({ 
                    iaLoading: false, 
                    internalAccount: `${user.first_name} ${user.last_name} ${role}`
                });
            })
            .catch(() => {
                this.setState({ 
                    iaLoading: false, 
                    internalAccount: 'Unable to retrieve IA'
                });
            });
        }
        else {
            this.setState({
                iaLoading: false,
                internalAccount: 'N/A'
            });
        }
    }

    render() {
        const actionTime = moment.utc(this.props.rowData.action_time).tz(this.props.timeZone).format('ll LTS z');
        
        return (
            <tr>
                <td>{actionTime}</td>
                <td>{this.props.rowData.order_id}</td>
                <td>{this.props.rowData.reservation_number}</td>
                <td>
                    <Spinner isSpinning={this.state.iaLoading} size="xs" />
                    {this.state.internalAccount}
                </td>
                <td>{this.props.rowData.action}</td>
            </tr>
        );
    }
};

ReservationHistoryRow.propTypes = {
    rowData: PropTypes.object.isRequired,
    timeZone: PropTypes.string.isRequired,
    isInternal: PropTypes.bool.isRequired,
    location: PropTypes.string
};
